import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = { class: "clearfix" };
const _hoisted_2 = { class: "x_panel" };
const _hoisted_3 = { class: "x_content" };
const _hoisted_4 = { class: "clearfix" };
const _hoisted_5 = { class: "col-xs-12 col-sm-12 col-md-1" };
const _hoisted_6 = { class: "col-xs-12 col-sm-12 col-md-1" };
const _hoisted_7 = { class: "col-xs-12 col-sm-12 col-md-6" };
const _hoisted_8 = {
    key: 0,
    class: "clearfix"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_b_form_input = _resolveComponent("b-form-input");
    const _component_b_button = _resolveComponent("b-button");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _cache[10] || (_cache[10] = _createElementVNode("div", { class: "x_title" }, [
                _createElementVNode("h2", null, "\r\n\t\t\t\t\tSettings\r\n\t\t\t\t"),
                _createTextVNode(),
                _createElementVNode("div", { class: "clearfix" })
            ], -1 /* CACHED */)),
            _cache[11] || (_cache[11] = _createTextVNode()),
            _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                    _cache[4] || (_cache[4] = _createElementVNode("div", { class: "col-xs-12 col-sm-12 col-md-2" }, [
                        _createElementVNode("label", null, "\r\n\t\t\t\t\t\t\tDaily alarm email limit per system and contact\r\n\t\t\t\t\t\t")
                    ], -1 /* CACHED */)),
                    _cache[5] || (_cache[5] = _createTextVNode()),
                    _createElementVNode("div", _hoisted_5, [
                        _createVNode(_component_b_form_input, {
                            type: "number",
                            modelValue: _ctx.maxDailyAlarmEmailLimitPerSystem,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.maxDailyAlarmEmailLimitPerSystem) = $event)),
                            min: _ctx.lowerLimit,
                            max: _ctx.upperLimit
                        }, null, 8 /* PROPS */, ["modelValue", "min", "max"])
                    ]),
                    _cache[6] || (_cache[6] = _createTextVNode()),
                    _cache[7] || (_cache[7] = _createElementVNode("div", { class: "col-xs-12 col-sm-12 col-md-2" }, [
                        _createElementVNode("label", null, "\r\n\t\t\t\t\t\t\tDaily alarm SMS limit per system and contact\r\n\t\t\t\t\t\t")
                    ], -1 /* CACHED */)),
                    _cache[8] || (_cache[8] = _createTextVNode()),
                    _createElementVNode("div", _hoisted_6, [
                        _createVNode(_component_b_form_input, {
                            type: "number",
                            modelValue: _ctx.maxDailyAlarmSmsLimitPerSystem,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((_ctx.maxDailyAlarmSmsLimitPerSystem) = $event)),
                            min: _ctx.lowerLimit,
                            max: _ctx.upperLimit
                        }, null, 8 /* PROPS */, ["modelValue", "min", "max"])
                    ]),
                    _cache[9] || (_cache[9] = _createTextVNode()),
                    _createElementVNode("div", _hoisted_7, [
                        _createVNode(_component_b_button, {
                            type: "button",
                            variant: "outline-secondary",
                            onClick: _ctx.reset
                        }, {
                            default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                                    _createElementVNode("i", { class: "fa fa-refresh" }, null, -1 /* CACHED */),
                                    _createElementVNode("span", { class: "hidden-xs" }, " Reset limits", -1 /* CACHED */)
                                ]))]),
                            _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["onClick"]),
                        _cache[3] || (_cache[3] = _createTextVNode()),
                        (_ctx.isPowershieldUser)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(_ctx.whenLastResetLimits), 1 /* TEXT */))
                            : _createCommentVNode("v-if", true)
                    ])
                ])
            ])
        ])
    ]));
}
